webpackJsonp([90179704293519],{

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Post = __webpack_require__(43);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryTemplateDetails = function (_React$Component) {
	  _inherits(CategoryTemplateDetails, _React$Component);
	
	  function CategoryTemplateDetails() {
	    _classCallCheck(this, CategoryTemplateDetails);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CategoryTemplateDetails.prototype.render = function render() {
	    var items = [];
	    var category = this.props.category.category;
	
	    var posts = this.props.posts;
	    posts.forEach(function (post) {
	      items.push(_react2.default.createElement(_Post2.default, { data: post, key: post.node.fields.slug }));
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'content__inner' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'page__title' },
	            category
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'page__body' },
	            items
	          )
	        )
	      )
	    );
	  };
	
	  return CategoryTemplateDetails;
	}(_react2.default.Component);
	
	exports.default = CategoryTemplateDetails;
	module.exports = exports['default'];

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _moment = __webpack_require__(78);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Post = function (_React$Component) {
	  _inherits(Post, _React$Component);
	
	  function Post() {
	    _classCallCheck(this, Post);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Post.prototype.render = function render() {
	    var _props$data$node$fron = this.props.data.node.frontmatter,
	        title = _props$data$node$fron.title,
	        date = _props$data$node$fron.date,
	        category = _props$data$node$fron.category,
	        description = _props$data$node$fron.description;
	    var _props$data$node$fiel = this.props.data.node.fields,
	        slug = _props$data$node$fiel.slug,
	        categorySlug = _props$data$node$fiel.categorySlug;
	
	
	    return (
	      // <div className="post">
	      //   <div className="post__meta">
	      //     <time className="post__meta-time" dateTime={moment(date).format('MMMM D, YYYY')}>
	      //       {moment(date).format('DD MMM YYYY')}
	      //     </time>
	      //     <span className="post__meta-divider">under</span>
	      //     <span className="post__meta-category" key={categorySlug}>
	      //       <Link to={categorySlug} className="post__meta-category-link">
	      //         {category}
	      //       </Link>
	      //     </span>
	      //   </div>
	      //   <h2 className="post__title">
	      //     <Link className="post__title-link" to={slug}>{title}</Link>
	      //   </h2>
	      //   <p className="post__description">{description}</p>
	      //   <Link className="post__readmore" to={slug}>Continue reading</Link>
	      // </div>
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'post__title-link', to: slug },
	          title
	        ),
	        _react2.default.createElement(
	          'span',
	          { 'class': 'opst__meta-category' },
	          ' ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: categorySlug, className: 'post__meta-category-link' },
	            ' ',
	            category
	          )
	        )
	      )
	    );
	  };
	
	  return Post;
	}(_react2.default.Component);
	
	exports.default = Post;
	module.exports = exports['default'];

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Sidebar = __webpack_require__(23);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _CategoryTemplateDetails = __webpack_require__(224);
	
	var _CategoryTemplateDetails2 = _interopRequireDefault(_CategoryTemplateDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryTemplate = function (_React$Component) {
	  _inherits(CategoryTemplate, _React$Component);
	
	  function CategoryTemplate() {
	    _classCallCheck(this, CategoryTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CategoryTemplate.prototype.render = function render() {
	    var title = this.props.data.site.siteMetadata.title;
	    var category = this.props.pathContext.category;
	    var posts = this.props.data.allMarkdownRemark.edges;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: category + ' - ' + title }),
	      _react2.default.createElement(_Sidebar2.default, { siteMetadata: this.props.data.site.siteMetadata }),
	      _react2.default.createElement(_CategoryTemplateDetails2.default, { category: category, posts: posts })
	    );
	  };
	
	  return CategoryTemplate;
	}(_react2.default.Component);
	
	exports.default = CategoryTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-category-template-jsx-c0b8a28c4528df068f4a.js